/**
 *  Point of contact for component modules
 *
 *  ie: import { Index, NotFound } from 'views';
 *
 */

import * as notFoundModule from './NotFound/NotFound'

export { default as App } from './App/App'
export { default as Index } from './Index/Index'
export const NotFound = notFoundModule.default
